import { render, staticRenderFns } from "./MyDate.vue?vue&type=template&id=1aa6c72e"
import script from "./MyDate.vue?vue&type=script&lang=js"
export * from "./MyDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports